import { useSyncExternalStore } from 'react'

// Телефонная раскладка — всё до md (768px): ниже него сайдбар уезжает в drawer,
// календарь переключается на дневной вид, попапы становятся bottom-sheet'ами.
export const MOBILE_QUERY = '(max-width: 47.9375rem)'

const NOOP = () => () => {}
const FALSE = () => false

/**
 * Реактивный matchMedia. Значение читается из живого MediaQueryList (не из
 * состояния), поэтому смена ориентации/размера окна перерисовывает подписчиков
 * без эффекта-синхронизатора. Среды без matchMedia (SSR, тест-DOM) дают false.
 */
export function useMediaQuery(query: string): boolean {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function'

  const subscribe = supported
    ? (onChange: () => void) => {
        const mql = window.matchMedia(query)
        mql.addEventListener('change', onChange)
        return () => mql.removeEventListener('change', onChange)
      }
    : NOOP

  const getSnapshot = supported ? () => window.matchMedia(query).matches : FALSE

  return useSyncExternalStore(subscribe, getSnapshot, FALSE)
}

/** Телефонная раскладка (< md). */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY)
}
